module.exports = __webpack_public_path__ + "static/media/medalha-diamante.6de0f68a.png";